
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/LoginPage/LoginPage";
import MainPage from "./pages/MainPage/MainPage";
import GlobalToast from "./Components/GlobalToast/GlobalToast";

const isLoggedIn = () => !!localStorage.getItem('teacher_authToken');

// Token varsa keçir, yoxdursa login-ə
const ProtectedRoute = ({ children }) => {
  return isLoggedIn() ? children : <Navigate to="/" replace />;
};

// Token varsa login-dən main-ə yönləndir
const PublicRoute = ({ children }) => {
  return isLoggedIn() ? <Navigate to="/main" replace /> : children;
};

function App() {
  return (
    <HashRouter>
      <GlobalToast />
      <Routes>
        <Route path="/" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/main/*" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}

export default App;